import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { injectIntl, FormattedMessage, IntlProvider } from 'react-intl'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import startsWith from 'lodash/startsWith'
import { withToast } from '@vtex/styleguide/lib/ToastProvider'
import msk from 'msk'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import SummaryView from '@/checkout-instore-legacy/components/Commons/Summary/containers/SummaryViewContainer'
import FooterButton from '@/checkout-instore-legacy/components/Commons/Elements/FooterButton'
import withOrderFormAndVendor from '@/checkout-instore-legacy/order/withOrderFormAndVendor'
import {
  getOrderForm,
  getCountryCode,
} from '@/checkout-instore-legacy/utils/orderFormUtils'
import { isInStoreAnonymousEmail } from '@/checkout-instore-legacy/utils/EmailUtils'
import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'
import customerShape from '@/checkout-instore-legacy/customer/shapes'
import {
  getProfileLabels,
  getCleanCustomer,
  pickProfileDataFromFormData,
} from '@/checkout-instore-legacy/customer/utils'
import InvoiceAddress from '@/checkout-instore-legacy/shipping/containers/InvoiceAddressContainer'
import emptyProfile from '@vtexlab/instore-profile/lib/modules/emptyProfile'

import debounce from 'lodash/debounce'
import isEmpty from 'lodash/isEmpty'
import { getIntlLocale } from '@/checkout-instore-legacy/i18n/utils'
import ProfileContainer from './ProfileContainer'
import { CustomerFields, ProfileFields } from './RegisterFields'

export class Register extends Component {
  constructor(props) {
    super(props)

    this.orderForm = getOrderForm()

    const customerData = this.retrieveCustomerData(this.orderForm)
    const isAnonymous = isInStoreAnonymousEmail(customerData.email)

    const {
      customerProfile: {
        isCorporate: isCorporateConfig,
        showInvoiceAddressOnRegister,
      },
    } = getInstoreConfig()

    this.showInvoiceAddressOnRegister = showInvoiceAddressOnRegister

    const isCorporate = !!isCorporateConfig
    const showCorporateToggle = isCorporateConfig && isCorporateConfig.optional

    this.labels = getProfileLabels()

    const showCorporate =
      isCorporate && !isAnonymous
        ? !showCorporateToggle || !!customerData.corporateDocument
        : false

    this.state = {
      ...pickProfileDataFromFormData(customerData, showCorporate),
      profile: emptyProfile,
      profileCountry: getCountryCode(this.orderForm),
      showCorporateToggle,
      isAnonymous,
      isCorporate,
      showCorporate,
      noStateInscription:
        (customerData && isEmpty(customerData.stateInscription)) || false,
      preRegister: false,
      isInvoiceAddressValid: true,
      invalidForm: true,
    }
  }

  retrieveCustomerData = (orderForm) => {
    const { customer } = this.props
    const customerData = getCleanCustomer(customer.profile)
    const { clientProfileData = {} } = orderForm

    if (!customerData.email || isInStoreAnonymousEmail(customerData.email)) {
      return clientProfileData || emptyProfile
    }
    return customerData
  }

  getCustomerProfile = (customerData, isAnonymous) => {
    const profileFieldsAnounymous = ['email', 'firstName']

    customerData.document =
      this.state.profileCountry === 'BRA'
        ? msk.fit(customerData.document, '999.999.999-99')
        : customerData.document

    if (isAnonymous) {
      profileFieldsAnounymous.map((field) => (customerData[field] = ''))

      return customerData
    }

    CustomerFields.map(
      (field) => (customerData[ProfileFields[field]] = customerData[field])
    )

    return customerData
  }

  componentDidMount() {
    this.setProfileLocale()
  }

  async setProfileLocale(
    lang = getIntlLocale() === null ? 'pt' : getIntlLocale()
  ) {
    const locale = await import(
      `@vtexlab/instore-profile/lib/locales/${lang}.json`
    )
    this.setState({ locale })
  }

  handleIsInvoiceAddressValid = (isInvoiceAddressValid) => {
    this.setState({ isInvoiceAddressValid })
  }

  handleValidateForm = ({
    isValid,
    profile,
    validateEmail,
    showCorporate,
    noStateInscription,
  }) => {
    this.setState(
      { profile, invalidForm: !isValid, showCorporate, noStateInscription },
      () => {
        if (validateEmail) {
          this.onEmailChange('email', profile.email, validateEmail)
        }
      }
    )
  }

  debouncerAutocompleteCustomer = debounce(() => {
    this.autocompleteCustomer()
  }, 800)

  onEmailChange = (stateId, value, validateEmail) => {
    this.setState({ email: value, isAnonymous: false }, () => {
      if (validateEmail) {
        this.debouncerAutocompleteCustomer()
      } else {
        this.debouncerAutocompleteCustomer.cancel()
      }
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()

    const { invalidForm, isInvoiceAddressValid } = this.state

    if (invalidForm || !isInvoiceAddressValid) {
      return
    }
    const { profile } = this.state

    CustomerFields.map(
      (field) => (profile[field] = profile[ProfileFields[field]])
    )

    profile.corporatePhone = isEmpty(profile.businessPhone)
      ? profile.phone
      : profile.businessPhone

    profile.stateInscription = this.state.noStateInscription
      ? this.labels.noStateInscription
      : profile.stateRegistration

    const profileData = {
      ...pickProfileDataFromFormData(this.state, this.state.showCorporate),
      ...profile,
    }

    if (this.showInvoiceAddressOnRegister && this.invoiceAddressRef) {
      this.invoiceAddressRef.handleSubmit()
    }

    this.handleCustomerStateUpdate(profileData)
  }

  handleCustomerStateUpdate = (profileData) => {
    const customerData = {
      ...profileData,
    }

    const { location } = this.props

    const { next } = location.query

    const { updateCustomer } = this.props

    let path = 'goBack'

    if (!isEmpty(next)) {
      path = startsWith(next, '/') ? next : `/${next}`
    }

    // update customer in redux state if data changed
    updateCustomer(customerData, path)
  }

  renderFooterButton = () => {
    const { loading, checkoutLoading, isOnline } = this.props
    const { invalidForm, isInvoiceAddressValid } = this.state

    return (
      <FooterButton
        id="save-customer-data"
        type="submit"
        disabled={!isOnline || invalidForm || !isInvoiceAddressValid}
        isLoading={loading || checkoutLoading}
      >
        {this.labels.confirm}
      </FooterButton>
    )
  }

  autocompleteCustomer = () => {
    const { profile } = this.state
    const { setCustomer, clearCustomer } = this.props
    // if email is valid and different from current, start searching the customer
    clearCustomer()
    setCustomer({ identification: profile.email, fromRegisterForm: true })
  }

  render() {
    const { isCorporate, showCorporateToggle } = this.state

    const { checkoutLoading } = this.props

    const customerData = { ...this.retrieveCustomerData(this.orderForm) }

    const showCorporate =
      isCorporate && !isAnonymous
        ? !showCorporateToggle || !!customerData.corporateDocument
        : false

    const noStateInscription =
      showCorporate &&
      (customerData.stateInscription === this.labels.noStateInscription ||
        isEmpty(customerData.stateInscription))

    const isAnonymous =
      isInStoreAnonymousEmail(customerData.email) ||
      isEmpty(customerData.firstName)

    const customerProfile = this.getCustomerProfile(
      customerData,
      isInStoreAnonymousEmail(customerData.email)
    )

    return (
      <SummaryView
        ref={(ele) => {
          this.registerFormRef = ele
        }}
        containerType="form"
        renderFooterButton={this.renderFooterButton}
        onSubmit={this.handleSubmit}
        disableAutocomplete
      >
        <div id="pre-register-extension" className={'dn'} />
        {!this.state.preRegister ? (
          <div className="flex flex-auto bg-light-silver overflow-auto justify-center">
            <div className="flex-auto bg-light-silver pt4 mt5-m mt6-l mh8-m mw8">
              <div className="ph7-ns mb8">
                <div id="register-extension-begin" className={'dn'} />
                <div className="ph5 pt4">
                  <div className="pt6">
                    <IntlProvider
                      messages={this.state.locale}
                      textComponent="span"
                    >
                      <ProfileContainer
                        onChange={this.handleValidateForm}
                        loading={checkoutLoading}
                        customer={customerProfile}
                        isAnonymous={isAnonymous}
                        noStateInscription={noStateInscription}
                        isCorporate={isCorporate}
                        showCorporate={showCorporate}
                        showCorporateToggle={showCorporateToggle}
                      />
                    </IntlProvider>
                  </div>
                </div>
                <div id="register-extension-end" className="dn" />

                {this.showInvoiceAddressOnRegister ? (
                  <div>
                    <h5 className="t-heading-6 ph5 mt5 mb7">
                      <FormattedMessage id="customerInvoiceAddress" />
                    </h5>
                    <InvoiceAddress
                      onChangeValidState={this.handleIsInvoiceAddressValid}
                      ref={(invoiceAddressRef) => {
                        this.invoiceAddressRef =
                          invoiceAddressRef &&
                          invoiceAddressRef.getWrappedInstance
                            ? invoiceAddressRef.getWrappedInstance()
                            : invoiceAddressRef
                      }}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        ) : null}
      </SummaryView>
    )
  }
}

Register.defaultProps = {
  loading: false,
  isOnline: true,
}

Register.propTypes = {
  router: PropTypes.any,
  location: PropTypes.object,
  intl: intlShape.isRequired,
  customer: customerShape,
  loading: PropTypes.bool,
  checkoutLoading: PropTypes.bool,
  updateCustomer: PropTypes.func,
  setCustomer: PropTypes.func,
  showErrorMessage: PropTypes.func,
  showToast: PropTypes.func,
  isOnline: PropTypes.bool,
}

export default withToast(
  injectIntl(withOrderFormAndVendor(withRouter(Register)))
)
